// `window.floorPlanControls` is how the floor plan's zoom rail, its PDF
// export and its room framing reach the canvas (`UVFloorPlanCanvas`). More
// than one canvas can be mounted at once — Fix All's and Layouts' previews
// over the plan, the construction documents' capture — and each used to set
// the global on mount and DELETE it on unmount, so closing a preview left the
// plan's zoom buttons dead until it happened to redraw.
//
// Now each installs its own and the newest answers; one going away gives the
// controls back to the one before it. A read-only canvas has no zoom or pan
// of its own (that is what `readOnly` means), so it installs nothing.

const installed = [];

/** Install `controls`; returns the function that takes them back. */
export function installFloorPlanControls(controls, { readOnly = false } = {}) {
  if (readOnly) return () => {};
  installed.push(controls);
  window.floorPlanControls = controls;
  return () => {
    const at = installed.lastIndexOf(controls);
    if (at >= 0) installed.splice(at, 1);
    if (window.floorPlanControls !== controls) return;
    if (installed.length)
      window.floorPlanControls = installed[installed.length - 1];
    else delete window.floorPlanControls;
  };
}
